import { uiStatePluginKey } from '../../editor-core';

export default function useUIStatePlugin(editorState) {
  let uiState = {
    showDiff: false,
    readOnly: false,
    historyMode: false
  };
  return editorState ? uiStatePluginKey.getState(editorState) : uiState;
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/hooks/useUIStatePlugin.js